import { queryOptions, useQuery } from '@tanstack/react-query'

import { inviteKeys } from './query-key-factory'

import { QueryConfig } from '@/lib/react-query'
import { supabase } from '@/lib/supabase-client'
import { logger } from '@/logger'

export type UserConnection = {
  connectionId: string
  connectedUserId: string
  connectedUserName: string
  connectedUserRole: 'practician' | 'technician'
  connectedUserEmail: string
  createdAt: string
}

export const getUserConnections = async (): Promise<UserConnection[]> => {
  const { data, error } = await supabase.rpc('get_user_connections')

  if (error) {
    logger.error('Failed to get user connections', { errorMessage: error })
    throw error
  }

  if (!data || !Array.isArray(data)) {
    return []
  }

  return data.map(
    (connection: {
      connection_id: string
      connected_user_id: string
      connected_user_name: string
      connected_user_role: 'practician' | 'technician'
      connected_user_email: string
      created_at: string
    }) => ({
      connectionId: connection.connection_id,
      connectedUserId: connection.connected_user_id,
      connectedUserName: connection.connected_user_name,
      connectedUserRole: connection.connected_user_role,
      connectedUserEmail: connection.connected_user_email,
      createdAt: connection.created_at,
    }),
  )
}

const getUserConnectionsQueryOptions = () => {
  return queryOptions({
    queryKey: inviteKeys.userConnections(),
    queryFn: getUserConnections,
  })
}

type UseGetUserConnectionsOptions = {
  queryConfig?: QueryConfig<typeof getUserConnectionsQueryOptions>
}

export const useGetUserConnections = ({ queryConfig }: UseGetUserConnectionsOptions = {}) => {
  return useQuery({
    ...getUserConnectionsQueryOptions(),
    ...queryConfig,
  })
}
